"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Tab = function Tab(_ref) {
  var id = _ref.id,
      title = _ref.title,
      description = _ref.description,
      Icon = _ref.icon,
      onTabClick = _ref.onTabClick,
      isActive = _ref.isActive;
  return _react["default"].createElement("div", {
    "data-testid": id,
    className: "tab ".concat(isActive ? 'tab-active' : ''),
    onClick: function onClick(event) {
      return onTabClick(event, id);
    }
  }, Icon ? _react["default"].createElement(Icon, {
    "data-testid": "icon-for-".concat(id),
    weight: "light",
    color: isActive ? _colors.coal : _colors.slate,
    size: "2x"
  }) : null, _react["default"].createElement("div", null, _react["default"].createElement("h5", {
    className: "tab-title ".concat(isActive ? 'tab-title-active' : '')
  }, title), description ? _react["default"].createElement("p", null, description) : null));
};

Tab.propTypes = {
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  icon: _propTypes["default"].func,
  onTabClick: _propTypes["default"].func.isRequired,
  isActive: _propTypes["default"].bool
};
var _default = Tab;
exports["default"] = _default;